// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__gVckG","title":"styles_title__4V2bj","inputs_wrapper":"styles_inputs_wrapper__5Q+Ge","input_wrapper":"styles_input_wrapper__dqkWA"};